import type { U3141ChildLotChain, U3141LotDetailDocument } from '../U3141Service';

/**
 * Aligne `lotDetail.documentTypes` (menu graphe) sur la liste GET documents après add/rename/delete.
 * Conserve `indexMostRecent` des entrées existantes (flag lotChainGraph).
 */
export function u3141SyncChildLotChainDocumentTypesFromDocumentsList(
  clc: U3141ChildLotChain,
  documents: U3141LotDetailDocument[],
): U3141ChildLotChain {
  if (!clc.lotDetail) {
    return clc;
  }
  const previousByType = new Map(
    (clc.lotDetail.documentTypes ?? [])
      .filter((e) => e?.documentType)
      .map((e) => [e.documentType, e]),
  );
  const nextDocumentTypes = documents
    .filter((doc) => doc?.id && doc.documentType)
    .map((doc) => {
      const prev = previousByType.get(doc.documentType!);
      return {
        id: String(doc.id),
        documentType: doc.documentType!,
        documentName: doc.documentName ?? null,
        ...(prev?.indexMostRecent != null ? { indexMostRecent: prev.indexMostRecent } : {}),
      };
    });
  return {
    ...clc,
    lotDetail: {
      ...clc.lotDetail,
      documentTypes: nextDocumentTypes,
    },
  };
}
